// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"10":"7d46f1fd","117":"9b034b26","154":"d4b6ebaa","460":"bf310b7e","687":"7c4ed558"}[chunkId] + ".chunk.js";
};